import { Badge, Card, Group, Table, Text } from '@mantine/core';
import { useQuery } from '@tanstack/react-query';
import { api, unwrap } from '../api.ts';
import { Empty, Failure, Loading, Page } from '../ui.tsx';

export function ContractsPage() {
  const contracts = useQuery({ queryKey: ['contracts'], queryFn: () => unwrap(api().GET('/v1/contracts')) });
  const organizations = useQuery({
    queryKey: ['organizations'],
    queryFn: () => unwrap(api().GET('/v1/organizations')),
  });
  const buildings = useQuery({ queryKey: ['buildings'], queryFn: () => unwrap(api().GET('/v1/buildings')) });
  const name = (id: string) =>
    organizations.data?.find((organization) => organization.id === id)?.name ?? '…';
  const building = (id: string) => buildings.data?.find((candidate) => candidate.id === id)?.name ?? '…';
  const today = new Date().toISOString().slice(0, 10);
  return (
    <Page title="Contracts" description="Which organization may use which building, and from when.">
      <Card withBorder padding="lg">
        {contracts.isPending ? <Loading /> : null}
        <Failure error={contracts.error} />
        {contracts.data?.length === 0 ? <Empty>No contracts yet.</Empty> : null}
        {contracts.data && contracts.data.length > 0 ? (
          <Table.ScrollContainer minWidth={640}>
            <Table>
              <Table.Thead>
                <Table.Tr>
                  <Table.Th>Provider</Table.Th>
                  <Table.Th>Recipient</Table.Th>
                  <Table.Th>Building</Table.Th>
                  <Table.Th>Valid</Table.Th>
                  <Table.Th>Spaces</Table.Th>
                </Table.Tr>
              </Table.Thead>
              <Table.Tbody>
                {contracts.data.map((contract) => {
                  const current =
                    contract.validFrom <= today && (contract.validTo === null || contract.validTo >= today);
                  return (
                    <Table.Tr key={contract.id}>
                      <Table.Td>{name(contract.providerOrganizationId)}</Table.Td>
                      <Table.Td fw={600}>{name(contract.recipientOrganizationId)}</Table.Td>
                      <Table.Td>{building(contract.buildingId)}</Table.Td>
                      <Table.Td>
                        <Group gap="xs" wrap="nowrap">
                          <Text size="sm">
                            {contract.validFrom} – {contract.validTo ?? 'open'}
                          </Text>
                          <Badge size="xs" variant="light" color={current ? 'green' : 'gray'}>
                            {current ? 'current' : 'not current'}
                          </Badge>
                        </Group>
                      </Table.Td>
                      <Table.Td>
                        {contract.spaceIds.length === 0 ? 'Whole building' : contract.spaceIds.length}
                      </Table.Td>
                    </Table.Tr>
                  );
                })}
              </Table.Tbody>
            </Table>
          </Table.ScrollContainer>
        ) : null}
      </Card>
    </Page>
  );
}
